export default __webpack_public_path__ + "static/CharterITCW05-Italic-6419612906b86be8853db8cc722087ae.woff";